const environmentTable = {
  playoutd1: 'ChannelMon',
  playoutd2: 'ChannelTue',
  playoutd3: 'ChannelWed',
  playoutd4: 'ChannelThu',
  playoutd5: 'ChannelFri',
  playoutd6: 'ChannelSat',
  playoutd7: 'ChannelSun',
  playout2: 'ChannelThuCopy',
  playout6: 'Production1',
  playout7: 'Production2',
  playout12: 'Production3',
  playout3: 'ProductionA',
  playout4: 'ProductionB',
  playout14: 'productionTenA',
  playout15: 'productionTenB',
  playout10: 'productionBlazeA',
  playout11: 'productionBlazeB',
  playout8: 'productionFoxA',
  playout9: 'productionFoxB',
  playout13: 'productionFoxC',
  playout0: 'ProductionU',
  playout5: 'productionUB',
  playout1: 'ChannelTaskEnv'
}

export { environmentTable }
